<template>
  <div class="color-picker">
    <v-text-field
      ref="colorTextInput"
      v-model="value"
      :bg-color="value"
      :label="label"
      :placeholder="placeholder"
      :rules="rules"
      @update:focused="onInputFocus"
      @click:clear="handleClear"
      append-inner-icon="mdi-format-color-fill"
      variant="solo-filled"
      :clearable="clearable"
      flat readonly required block
    />

    <v-overlay
      v-model="isVisible"
      location-strategy="connected"
      target="parent"
      :scrim="false"
      :close-on-back="false"
      :close-on-content-click="false"
      min-width="0"
    >
      <v-color-picker
        :model-value="value"
        @update:model-value="colorPickerValueUpdated"
        class="ma-2"
        dot-size="10"
        :mode="mode"
      />
    </v-overlay>
  </div>
</template>

<script>
import { defineComponent, reactive, nextTick } from 'vue';

const globalState = reactive({
  id: 1,
  openId: null,
  nextId() {return this.id++ },
  open(id) { this.openId = id }
})

export default defineComponent({
  name: 'ColorPicker',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    rules: {
      type: Array,
      required: false,
    },
    mode: {
      type: String,
      required: false,
      default: 'rgb',
    },
    clearable: {
      type: Boolean,
      required: false,
    },
  },
  emits: ['update:modelValue'],
  setup() {
    return {
      colorPickerId: globalState.nextId()
    }
  },
  data() {
    return {
      isColorPickerOpen: false,
      selectedColor: this.modelValue,
      isVisible: false,
      globalState,
    };
  },
  watch: {
    'globalState.openId': function (val) {
      if (val !== this.colorPickerId) {
        this.isVisible = false;
      }
    }
  },
  methods: {
    onInputFocus: function(val) {
      if (val) {
        this.isVisible = true;
        this.globalState.open(this.colorPickerId);
      }
    },
    handleClear: function() {
      nextTick(() => {
        this.$refs.colorTextInput.blur()
      });
    },
    colorPickerValueUpdated: function (val) {
      if (this.mode === 'rgba') {
        this.value = val.padEnd(9, 'FF');
      } else {
        this.value = val;
      }
    },
  },
  computed: {
    value: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      }
    }
  }
})
</script>

<style scoped>

</style>
